import { forwardRef, createElement } from 'react';

function IconAttachCancel(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.026 18.467a.75.75 0 01-.977 1.133l-.084-.073-2.288-2.288-3.005 3.006a5.25 5.25 0 01-7.574-7.269l.15-.156 3.005-3.005-2.288-2.288a.75.75 0 01.977-1.133l.084.073 12 12zm-9.713-7.592l-3.005 3.006a3.75 3.75 0 005.16 5.44l.144-.137 3.005-3.005-1.061-1.061-3.005 3.005a2.25 2.25 0 01-3.287-3.069l.105-.113 3.005-3.005-1.061-1.061zm2.122 2.122L8.43 16.002a.75.75 0 00.984 1.128l.076-.067 3.005-3.006-1.06-1.06zm7.894-.47a.75.75 0 01.067.984l-.067.077-1.53 1.53-1.061-1.061 1.53-1.53a.75.75 0 011.061 0zm.354-8.839a3.75 3.75 0 01.137 5.16l-.137.144-4.006 4.004-1.06-1.06 4.005-4.005a2.25 2.25 0 00-3.07-3.287l-.112.105-4.005 4.005-1.061-1.061 4.005-4.005a3.75 3.75 0 015.304 0zm-4.596 4.597a.75.75 0 01.067.983l-.067.077-1.531 1.53-1.061-1.061 1.53-1.53a.75.75 0 011.062 0z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var AttachCancel = /*#__PURE__*/forwardRef(IconAttachCancel);

export default AttachCancel;
//# sourceMappingURL=AttachCancel.js.map
